<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->


<span class="d-flex col-12 align-items-center px-3 mt">
    <span class="col-10" style="">
      <p-select
        dataKey="field"
        [dropdownIcon]="'none'"
        [options]="sortModels"
        [disabled]="disabled"
        [ngModel]="sortMeta.field"
        appendTo="body"
        (onChange)="sortFieldChange($event)"
        styleClass="full-width full-height"
       data-testid="select">
    </p-select>
    </span>


    <span class="col-2 d-flex align-items-center justify-center">
      <i class="pi cursor-pointer sort-icon" (click)="sortChange()"
         [ngClass]="{'pi-arrow-up': sortMeta.order===1, 'pi-arrow-down': sortMeta.order===-1}">
      </i>
    </span>
  </span>
